module.exports = __webpack_public_path__ + "static/img/auto-rewards-splash.88efabf6.png";